import { useState, type FormEvent } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "全部快讯", to: "/news" },
  { label: "明星八卦", to: "/category/hot-gossip" },
  { label: "综艺爆料", to: "/category/variety" },
  { label: "影视动态", to: "/category/screen" },
  { label: "网红热榜", to: "/category/influencer" },
  { label: "关于我们", to: "/about" },
];

export default function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [keyword, setKeyword] = useState("");

  const isActive = (to: string) =>
    to === "/" ? location.pathname === "/" : location.pathname.startsWith(to);

  const submitSearch = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const kw = keyword.trim();
    setSearchOpen(false);
    setMenuOpen(false);
    navigate(kw ? `/news?q=${encodeURIComponent(kw)}` : "/news");
  };

  return (
    <header className="sticky top-0 z-50 bg-background-50/95 backdrop-blur border-b border-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 h-16 md:h-[70px] flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-2.5 shrink-0 cursor-pointer">
          <span className="w-10 h-10 rounded-lg bg-primary-500 flex items-center justify-center text-background-50 font-heading text-xl font-bold">
            瓜
          </span>
          <span className="leading-none">
            <span className="block font-heading text-lg md:text-xl font-bold text-foreground-950 tracking-tight">
              独家吃瓜
            </span>
            <span className="hidden sm:block text-[11px] text-foreground-500 font-label tracking-wide mt-0.5">
              娱乐快讯 · 实时播报
            </span>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-1" aria-label="主导航">
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`px-3 py-2 rounded-md text-sm font-label transition-colors cursor-pointer whitespace-nowrap ${
                isActive(item.to)
                  ? "bg-primary-100 text-primary-700 font-medium"
                  : "text-foreground-700 hover:bg-background-200 hover:text-foreground-950"
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => setSearchOpen((open) => !open)}
            aria-label="搜索"
            className="w-10 h-10 flex items-center justify-center rounded-md text-foreground-700 hover:bg-background-200 transition-colors cursor-pointer"
          >
            <i className="ri-search-line text-lg"></i>
          </button>
          <Link
            to="/contact"
            className="hidden md:inline-flex items-center gap-1.5 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-label hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-send-plane-line"></i>
            爆料投稿
          </Link>
          <button
            type="button"
            onClick={() => setMenuOpen((open) => !open)}
            aria-label="菜单"
            className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-800 hover:bg-background-200 transition-colors cursor-pointer"
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
          </button>
        </div>
      </div>

      {searchOpen && (
        <div className="border-t border-background-200 bg-background-100">
          <form
            onSubmit={submitSearch}
            className="max-w-[1280px] mx-auto px-4 md:px-6 py-3 flex items-center gap-3"
          >
            <i className="ri-search-line text-foreground-500 text-lg"></i>
            <input
              type="text"
              value={keyword}
              onChange={(event) => setKeyword(event.target.value)}
              placeholder="搜索艺人、节目或关键词，例如「路透」「定档」"
              className="flex-1 bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 outline-none py-2 font-label"
            />
            <button
              type="submit"
              className="px-4 py-2 rounded-md bg-secondary-500 text-background-50 text-sm font-label hover:bg-secondary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              搜索
            </button>
          </form>
        </div>
      )}

      {menuOpen && (
        <div className="lg:hidden border-t border-background-200 bg-background-50">
          <nav className="px-4 py-3 grid grid-cols-2 gap-2" aria-label="移动端导航">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                onClick={() => setMenuOpen(false)}
                className={`px-3 py-2.5 rounded-md text-sm font-label transition-colors cursor-pointer ${
                  isActive(item.to)
                    ? "bg-primary-100 text-primary-700 font-medium"
                    : "bg-background-100 text-foreground-700 hover:bg-background-200"
                }`}
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/contact"
              onClick={() => setMenuOpen(false)}
              className="col-span-2 px-3 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-label text-center cursor-pointer"
            >
              爆料投稿
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}